import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import testimonialsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/testimonialsStyle.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

//icons
import Done from "@material-ui/icons/Done";
import Close from "@material-ui/icons/Close"


class ProblemSolutionSection extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    
    return (
      <div className="cd-section" {...rest}>
        <div
          style={{ backgroundColor:"#ffffff", paddingTop:"80px" }}
        >
          <div className={classes.container}>
            <GridContainer>
                <GridItem xs={12} sm={6} style={{textAlign:"left", paddingLeft:"60px", paddingRight:"60px"}}>
                    <h2 className={classes.title} style={{marginBottom:"0px", marginTop:"0px"}}>Problem</h2>
                    <h4 style={{color:"#545454"}}>Programs are developed in isolation, without school collaboration.</h4>
                    <hr />
                    <div>
                        <div style={{display:"inline-block"}}>
                            <Close style={{color:"red", marginRight:"10px", position:"relative", top:"6px", height:"21px"}} />
                        </div>
                        <div style={{display:"inline-block", fontSize:"14px", fontWeight:400}}>
                            Inflated Startup Costs
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div style={{display:"inline-block"}}>
                            <Close style={{color:"red", marginRight:"10px", position:"relative", top:"6px", height:"21px"}} />
                        </div>
                        <div style={{display:"inline-block", fontSize:"14px", fontWeight:400}}>
                            Requires lengthly professional development
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div style={{display:"inline-block"}}>
                            <Close style={{color:"red", marginRight:"10px", position:"relative", top:"6px", height:"21px"}} />
                        </div>
                        <div style={{display:"inline-block", fontSize:"14px", fontWeight:400}}>
                            Creates too much new work
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div style={{display:"inline-block", verticalAlign:"top"}}>
                            <Close style={{color:"red", marginRight:"10px", position:"relative", top:"6px", height:"21px"}} />
                        </div>
                        <div style={{display:"inline-block", fontSize:"14px", fontWeight:400, width:"80%"}}>
                            Trains, drains and ditches the schools who invested in their programs
                        </div>
                    </div>
                    <hr />
                </GridItem>
                <GridItem xs={12} sm={6} style={{textAlign:"left", paddingLeft:"60px", paddingRight:"60px"}}>
                    <h2 className={classes.title} style={{marginBottom:"0px", marginTop:"0px"}}>Solution</h2>
                    <h4 style={{color:"#545454"}}>A digital platform that includes teachers, students, parents and staff.</h4>
                    <hr />
                    <div>
                        <div style={{display:"inline-block"}}>
                            <Done style={{color:"green", marginRight:"10px", position:"relative", top:"6px", height:"21px"}} />
                        </div>
                        <div style={{display:"inline-block", fontSize:"14px", fontWeight:400}}>
                            Comparably low, sustainable cost
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div style={{display:"inline-block"}}>
                            <Done style={{color:"green", marginRight:"10px", position:"relative", top:"6px", height:"21px"}} />
                        </div>
                        <div style={{display:"inline-block", fontSize:"14px", fontWeight:400}}>
                            A digital platform that is easy to implement
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div style={{display:"inline-block"}}>
                            <Done style={{color:"green", marginRight:"10px", position:"relative", top:"6px", height:"21px"}} />
                        </div>
                        <div style={{display:"inline-block", fontSize:"14px", fontWeight:400}}>
                            Teachers participate, they don't plan
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div style={{display:"inline-block", verticalAlign:"top"}}>
                            <Done style={{color:"green", marginRight:"10px", position:"relative", top:"6px", height:"21px"}} />
                        </div>
                        <div style={{display:"inline-block", fontSize:"14px", width:"80%", fontWeight:400}}>
                            Ongoing daily, weekly support and a program that grows with your school year after year
                        </div>
                    </div>
                    <hr />
                </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(testimonialsStyle)(ProblemSolutionSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionProblemSolution.jsx